import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="confirm"
// Stimulus-based confirm dialog.
// Works on <form> elements (intercepts submit) and <a> elements (intercepts click).
// Add data-confirm-message-value="Your message" to the element.
export default class extends Controller {
  static values = { message: String }

  initialize() {
    const eventType = this.element.tagName === 'FORM' ? 'submit' : 'click'
    this.element.addEventListener(eventType, event => {
      if (!window.confirm(this.messageValue)) {
        event.preventDefault()
      }
    })
  }
}
